import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStatementAvailable = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M3.375 1.5H10.0039C10.269 1.50006 10.5235 1.60549 10.7109 1.79297L13.332 4.41406C13.5195 4.60155 13.6249 4.85596 13.625 5.12109V13.5C13.625 14.0523 13.1773 14.5 12.625 14.5H3.375C2.82272 14.5 2.375 14.0523 2.375 13.5V2.5C2.375 1.94772 2.82272 1.5 3.375 1.5Z",
		stroke: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5.43359 8.11667L7.06693 9.75L10.5669 6.25",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgStatementAvailable;
